import strings from 'utils/strings'
import {
  VOLT_0_18K5,
  VOLT_0_6,
  RES_0_100k,
  RES_0_500,
  VOLT_0_16_rel,
} from 'utils/constants'

import {
  SIGNAL_TRANSLATION_BOOLEAN_TYPES,
  SIGNAL_TRANSLATION_STATE_TYPES,
  SIGNAL_TRANSLATION_RANGE_LABELS,
} from 'constants/signals'

import { mapFrom } from 'utils/functional'

const BOOLEAN_TRANSLATIONS = {
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.OFF]: strings.signal_off,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.ON]: strings.signal_on,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.RELEASED]: strings.signal_released,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.PRESSED]: strings.signal_pressed,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.SET]: strings.signal_set,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.DISENGAGED]: strings.signal_disengaged,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.ENGAGED]: strings.signal_engaged,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.OPEN]: strings.signal_open,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.LATCHED]: strings.signal_latched,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.UNLOCKED]: strings.signal_unlocked,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.LOCKED]: strings.signal_locked,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.PLUS_12_VOLTS]:
    strings.signal_plus_12_volts,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.GROUNDED]: strings.signal_grounded,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.DEACTIVATED]: strings.signal_deactivated,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.ACTIVATED]: strings.signal_activated,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.ERROR]: strings.signal_error,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.NO_ERROR]: strings.signal_no_error,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.ENABLED]: strings.signal_enabled,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.DISABLED]: strings.signal_disabled,
  [SIGNAL_TRANSLATION_BOOLEAN_TYPES.NOT_AVAILABLE]: strings.signal_sna,
}

const STATE_TRANSLATIONS = {
  [SIGNAL_TRANSLATION_STATE_TYPES.OFF]: strings.signal_off,
  [SIGNAL_TRANSLATION_STATE_TYPES.RESERVED_FOR_SAE]:
    strings.signal_reserved_for_sae,
  [SIGNAL_TRANSLATION_STATE_TYPES.ON_SOLID]: strings.signal_on_solid,
  [SIGNAL_TRANSLATION_STATE_TYPES.ON_FAST_BLINK]: strings.signal_on_blink_fast,
  [SIGNAL_TRANSLATION_STATE_TYPES.ACCESSORY]: strings.signal_accessory,
  [SIGNAL_TRANSLATION_STATE_TYPES.RUN]: strings.signal_run,
  [SIGNAL_TRANSLATION_STATE_TYPES.CRANK]: strings.signal_crank,
  [SIGNAL_TRANSLATION_STATE_TYPES.REVERSE]: strings.signal_reverse,
  [SIGNAL_TRANSLATION_STATE_TYPES.NEUTRAL]: strings.signal_neutral,
  [SIGNAL_TRANSLATION_STATE_TYPES.GEAR_1]: strings.signal_gear_1,
  [SIGNAL_TRANSLATION_STATE_TYPES.GEAR_2]: strings.signal_gear_2,
  [SIGNAL_TRANSLATION_STATE_TYPES.GEAR_3]: strings.signal_gear_3,
  [SIGNAL_TRANSLATION_STATE_TYPES.GEAR_4]: strings.signal_gear_4,
  [SIGNAL_TRANSLATION_STATE_TYPES.GEAR_5]: strings.signal_gear_5,
  [SIGNAL_TRANSLATION_STATE_TYPES.GEAR_6]: strings.signal_gear_6,
  [SIGNAL_TRANSLATION_STATE_TYPES.PARK]: strings.signal_park,
  [SIGNAL_TRANSLATION_STATE_TYPES.UNAVAILABLE]: strings.signal_unavailable,
  [SIGNAL_TRANSLATION_STATE_TYPES.SINGLE_RUN]: strings.single_run_timer,
  [SIGNAL_TRANSLATION_STATE_TYPES.SINGLE_RUN_TIMER]: strings.single_run_timer,
  [SIGNAL_TRANSLATION_STATE_TYPES.REPEATING]: strings.repeating_timer,
  [SIGNAL_TRANSLATION_STATE_TYPES.REPEATING_TIMER]: strings.repeating_timer,
  [SIGNAL_TRANSLATION_STATE_TYPES.DISABLED]: strings.disabled,
  [SIGNAL_TRANSLATION_STATE_TYPES.DEACTIVATED]: strings.signal_deactivated,
  [SIGNAL_TRANSLATION_STATE_TYPES.ACTIVATED]: strings.signal_activated,
  [SIGNAL_TRANSLATION_STATE_TYPES.ERROR]: strings.signal_error,
  [SIGNAL_TRANSLATION_STATE_TYPES.NOT_AVAILABLE]: strings.signal_sna,
  [SIGNAL_TRANSLATION_STATE_TYPES.RELEASED]: strings.signal_released,
  [SIGNAL_TRANSLATION_STATE_TYPES.DEPRESSED]: strings.signal_depressed,
  [SIGNAL_TRANSLATION_STATE_TYPES.MARKER_ON]: strings.signal_marker_on,
  [SIGNAL_TRANSLATION_STATE_TYPES.HEADLIGHTS_ON]: strings.signal_headlights_on,
  [SIGNAL_TRANSLATION_STATE_TYPES.HEADLIGHTS_MARKER_ON]:
    strings.signal_headlights_markers_on,
  [SIGNAL_TRANSLATION_STATE_TYPES.AUTO]: strings.signal_auto,
  [SIGNAL_TRANSLATION_STATE_TYPES.DELAYED_OFF]: strings.signal_delayed_off,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_0]: strings.signal_level_0,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_1]: strings.signal_level_1,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_2]: strings.signal_level_2,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_3]: strings.signal_level_3,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_4]: strings.signal_level_4,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_5]: strings.signal_level_5,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_6]: strings.signal_level_6,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_7]: strings.signal_level_7,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_8]: strings.signal_level_8,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_9]: strings.signal_level_9,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_10]: strings.signal_level_10,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_11]: strings.signal_level_11,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_12]: strings.signal_level_12,
  [SIGNAL_TRANSLATION_STATE_TYPES.LEVEL_13]: strings.signal_level_13,
  [SIGNAL_TRANSLATION_STATE_TYPES.TRAILER_DETECTED]:
    strings.signal_trailer_detected,
  [SIGNAL_TRANSLATION_STATE_TYPES.TRAILER_NOT_DETECTED]:
    strings.signal_trailer_not_detected,
  [SIGNAL_TRANSLATION_STATE_TYPES.TRAILER_ALARM]: strings.signal_trailer_alarm,
  [SIGNAL_TRANSLATION_STATE_TYPES.INTERMITTENT_1]:
    strings.signal_intermittent_1,
  [SIGNAL_TRANSLATION_STATE_TYPES.INTERMITTENT_2]:
    strings.signal_intermittent_2,
  [SIGNAL_TRANSLATION_STATE_TYPES.INTERMITTENT_3]:
    strings.signal_intermittent_3,
  [SIGNAL_TRANSLATION_STATE_TYPES.INTERMITTENT_4]:
    strings.signal_intermittent_4,
  [SIGNAL_TRANSLATION_STATE_TYPES.INTERMITTENT_5]:
    strings.signal_intermittent_5,
  [SIGNAL_TRANSLATION_STATE_TYPES.LOW]: strings.signal_low,
  [SIGNAL_TRANSLATION_STATE_TYPES.HIGH]: strings.signal_high,
}

export const signalTranslation = mapFrom({
  ...BOOLEAN_TRANSLATIONS,
  ...STATE_TRANSLATIONS,
})

export const signalTranslationRangeSymbolLabel = mapFrom({
  [SIGNAL_TRANSLATION_RANGE_LABELS.MPH]: strings.signal_mph,
  [SIGNAL_TRANSLATION_RANGE_LABELS.RPM]: strings.signal_rpm,
  [SIGNAL_TRANSLATION_RANGE_LABELS.V]: strings.signal_v,
  [SIGNAL_TRANSLATION_RANGE_LABELS.OHM]: strings.signal_ohm,
  [SIGNAL_TRANSLATION_RANGE_LABELS.KOHM]: strings.signal_kohm,
  [SIGNAL_TRANSLATION_RANGE_LABELS.PERCENT]: strings.signal_percent,
  [SIGNAL_TRANSLATION_RANGE_LABELS.FAHRENHEIT]: strings.signal_f,
  [SIGNAL_TRANSLATION_RANGE_LABELS.kPa]: strings.signal_kpa,
})

export const featureSignalTranslationValueLabel = mapFrom({
  [SIGNAL_TRANSLATION_RANGE_LABELS.MPH]: strings.signal_mph,
  [SIGNAL_TRANSLATION_RANGE_LABELS.RPM]: strings.signal_rpm,
  [SIGNAL_TRANSLATION_RANGE_LABELS.V]: strings.signal_volts_label,
  [SIGNAL_TRANSLATION_RANGE_LABELS.OHM]: strings.signal_ohm,
  [SIGNAL_TRANSLATION_RANGE_LABELS.KOHM]: strings.signal_kohm,
  [SIGNAL_TRANSLATION_RANGE_LABELS.PERCENT]:
    strings.signal_relative_voltage_label,
  [SIGNAL_TRANSLATION_RANGE_LABELS.FAHRENHEIT]: strings.signal_fahrenheit,
  [SIGNAL_TRANSLATION_RANGE_LABELS.kPa]: strings.signal_kpa,
})

export const featureSignalTranslationValueTooltip = mapFrom({
  [VOLT_0_6]: strings.signal_measure_tooltip,
  [VOLT_0_18K5]: strings.signal_measure_tooltip,
  [RES_0_100k]: strings.signal_measure_tooltip,
  [RES_0_500]: strings.signal_measure_tooltip,
  [VOLT_0_16_rel]: strings.signal_relative_voltage_tooltip,
})
